import { useRef } from "react";
import { inBrowser } from "@lilib/utils";
import useUnmount from "./useUnmount";
import usePreviousRef from "./usePreviousRef";
function useTitle(title, options) {
  var oldTitleRef = useRef(inBrowser ? document.title : "");
  var prevTitleRef = usePreviousRef(title);
  if (inBrowser && title != null && title !== prevTitleRef.current) {
    document.title = title;
  }
  useUnmount(function () {
    if (inBrowser && options && options.restore) {
      document.title = oldTitleRef.current;
    }
  });
}
export default useTitle;